/**
 * Chinese translations for Hashee Admin Console.
 */
export const zh: Record<string, string> = {
  // ─── Common ───
  "common.loading": "\u52A0\u8F7D\u4E2D...",
  "common.search": "\u641C\u7D22",
  "common.apply": "\u5E94\u7528",
  "common.filter": "\u7B5B\u9009",
  "common.refresh": "\u5237\u65B0",
  "common.cancel": "\u53D6\u6D88",
  "common.confirm": "\u786E\u8BA4",
  "common.prev": "\u4E0A\u4E00\u9875",
  "common.next": "\u4E0B\u4E00\u9875",
  "common.previous": "\u4E0A\u4E00\u9875",
  "common.view": "\u67E5\u770B",
  "common.yes": "\u662F",
  "common.no": "\u5426",
  "common.date": "\u65E5\u671F",
  "common.status": "\u72B6\u6001",
  "common.created": "\u521B\u5EFA\u65F6\u95F4",
  "common.action": "\u64CD\u4F5C",
  "common.from": "\u4ECE",
  "common.to": "\u5230",
  "common.failed_to_load": "\u52A0\u8F7D\u5931\u8D25",
  "common.action_failed": "\u64CD\u4F5C\u5931\u8D25",
  "common.no_data_for_period": "\u8BE5\u65F6\u6BB5\u65E0\u6570\u636E",
  "common.show_details": "\u663E\u793A\u660E\u7EC6",
  "common.hide_details": "\u9690\u85CF\u660E\u7EC6",
  "common.all": "\u5168\u90E8",
  "stats.total": "\u603B\u8BA1",

  // ─── Route Error Boundary ───
  "route_error.kicker": "Admin \u8FD0\u884C\u65F6\u9519\u8BEF",
  "route_error.title": "\u8BE5\u540E\u53F0\u9875\u9762\u6E32\u67D3\u5931\u8D25",
  "route_error.description":
    "\u63A7\u5236\u53F0\u5DF2\u5728 React Router \u9ED8\u8BA4\u5D29\u6E83\u9875\u4E4B\u524D\u6355\u83B7\u5230\u8BE5\u9875\u9519\u8BEF\u3002\u8BF7\u68C0\u67E5\u5931\u8D25\u8DEF\u7531\u548C API \u54CD\u5E94\u540E\u91CD\u8F7D\u3002",
  "route_error.status": "\u72B6\u6001",
  "route_error.message": "\u9519\u8BEF",
  "route_error.unknown_message": "\u672A\u77E5\u8DEF\u7531\u9519\u8BEF",
  "route_error.back_home": "\u8FD4\u56DE\u4EEA\u8868\u76D8",
  "route_error.reload": "\u91CD\u8F7D\u9875\u9762",

  // ─── Sidebar ───
  "sidebar.logo": "Hashee \u8FD0\u7EF4",
  "sidebar.sign_out": "\u9000\u51FA\u767B\u5F55",
  "sidebar.collapse_nav": "\u6536\u8D77\u5BFC\u822A",
  "sidebar.expand_nav": "\u5C55\u5F00\u5BFC\u822A",
  "nav.dashboard": "\u4EEA\u8868\u76D8",
  "nav.metrics": "\u6307\u6807",
  "nav.integrations": "\u96C6\u6210",
  "nav.users": "\u7528\u6237",
  "nav.users.all": "\u6240\u6709\u7528\u6237",
  "nav.content": "\u5185\u5BB9",
  "nav.content.storage": "\u5B58\u50A8",
  "nav.content.storage_orphan_audit":
    "\u5B58\u50A8\u5B64\u7ACB\u5BF9\u8C61\u5BA1\u8BA1\uFF08\u5E72\u8DD1\uFF09",
  "nav.content.summary_jobs": "\u6458\u8981\u4EFB\u52A1",
  "nav.content.conversations": "\u4F1A\u8BDD",
  "nav.content.deliveries": "\u4EA4\u4ED8\u7269",
  "nav.revenue": "\u8425\u6536",
  "nav.revenue.billing": "\u8D26\u5355",
  "nav.governance": "\u6CBB\u7406",
  "nav.governance.relations": "\u5173\u7CFB",
  "nav.governance.blocks": "\u5C4F\u853D",
  "nav.governance.agents": "Agent",
  "nav.governance.agent_reviews": "Agent 审核",
  "nav.governance.grants": "\u6388\u6743",
  "nav.governance.audit_log": "\u5BA1\u8BA1\u65E5\u5FD7",
  "nav.governance.space_reports": "Space \u4E3E\u62A5",
  "nav.system": "\u7CFB\u7EDF",
  "nav.system.health": "\u5065\u5EB7\u72B6\u6001",
  "nav.system.communications": "\u901A\u4FE1",
  "nav.system.dlq": "\u6B7B\u4FE1\u961F\u5217",
  "nav.system.crashes": "\u5D29\u6E83\u62A5\u544A",
  "nav.system.backend_api_coverage":
    "\u540E\u7AEF API \u6D4B\u8BD5\u8986\u76D6",

  // ─── Login ───
  "login.title": "Hashee \u8FD0\u7EF4\u63A7\u5236\u53F0",
  "login.subtitle": "\u4F7F\u7528\u7BA1\u7406\u5458\u8D26\u53F7\u767B\u5F55",
  "login.email": "\u90AE\u7BB1",
  "login.password": "\u5BC6\u7801",
  "login.signing_in": "\u767B\u5F55\u4E2D...",
  "login.sign_in": "\u767B\u5F55",
  "login.dismiss_error": "\u5173\u95ED\u9519\u8BEF",

  // ─── Dashboard ───
  "dashboard.title": "\u4EEA\u8868\u76D8",
  "dashboard.description":
    "\u7CFB\u7EDF\u6982\u89C8\u4E0E\u5173\u952E\u6307\u6807",
  "dashboard.humans": "\u7528\u6237\u6570",
  "dashboard.paid_users": "\u4ED8\u8D39\u7528\u6237",
  "dashboard.summary_failed_24h": "\u6458\u8981\u5931\u8D25 (24h)",
  "dashboard.system_status": "\u7CFB\u7EDF\u72B6\u6001",
  "dashboard.status_healthy": "\u5065\u5EB7",
  "dashboard.status_degraded": "\u964D\u7EA7",
  "dashboard.status_down": "\u5B95\u673A",
  "dashboard.of_total": "\u5360\u603B\u6570",
  "dashboard.alerts": "\u544A\u8B66",
  "dashboard.no_active_alerts": "\u65E0\u6D3B\u52A8\u544A\u8B66",
  "dashboard.failed_summary_jobs":
    "\u4E2A\u6458\u8981\u4EFB\u52A1\u5728\u8FC7\u53BB 24 \u5C0F\u65F6\u5185\u5931\u8D25",
  "dashboard.view_summary_jobs": "\u67E5\u770B\u6458\u8981\u4EFB\u52A1",
  "dashboard.is_status": "\u72B6\u6001\u4E3A",
  "dashboard.cron_prefix": "\u5B9A\u65F6\u4EFB\u52A1",
  "dashboard.poison_messages":
    "\u4E2A\u6BD2\u6D88\u606F\u5728\u961F\u5217\u4E2D",
  "dashboard.view_system_health": "\u67E5\u770B\u7CFB\u7EDF\u5065\u5EB7",
  "dashboard.messages_today": "\u4ECA\u65E5\u6D88\u606F",
  "dashboard.relations": "\u5173\u7CFB",
  "dashboard.conversations": "\u4F1A\u8BDD",
  "dashboard.message_distribution": "\u6D88\u606F\u5206\u5E03 (30\u5929)",
  "dashboard.human_messages": "\u4EBA\u7C7B",
  "dashboard.agent_messages": "Agent",
  "dashboard.system_messages": "\u7CFB\u7EDF",
  "dashboard.vs_last_week": "上周同期：{{value}}",

  // ─── Status Bar ───
  "dashboard.status_alerts": "{{count}} 条告警",
  "dashboard.status_anomalous": "{{count}} 个 KPI 异常",
  "dashboard.status_normal": "{{count}} 个 KPI 正常",
  "dashboard.status_all_healthy": "全部正常",

  // ─── Dashboard Alerts ───
  "dashboard.all_systems_healthy": "所有系统健康",
  "dashboard.runbook_prefix": "操作建议:",

  // ─── Dashboard KPI Labels ───
  "dashboard.kpi_new_users": "新增用户",
  "dashboard.kpi_new_agents": "新增 Agent",
  "dashboard.kpi_dau": "日活",
  "dashboard.kpi_mrr": "月收入",
  "dashboard.group_label_short": "群组",

  // ─── Dashboard Social Trends ───
  "dashboard.social_trends_title": "社交趋势 (30天)",
  "dashboard.dim_by_type": "按类型",
  "dashboard.dim_by_agent": "按 Agent",
  "dashboard.dim_by_country": "按国家",
  "dashboard.h2a_label": "H2A 消息",
  "dashboard.h2h_label": "H2H 消息",
  "dashboard.group_label": "群组消息",
  "dashboard.funnel_title": "核心漏斗",

  // ─── Funnel Mini ───
  "funnel.step_register": "注册",
  "funnel.step_conversation": "对话",
  "funnel.step_summary": "摘要",
  "funnel.step_delivery": "推送",
  "funnel.step_share": "分享",
  "funnel.step_storage": "存储",
  "funnel.step_payment": "付款",
  "funnel.conversion_rate": "\u2193 {{percent}}%",
  "funnel.empty_hint":
    "\u6F0F\u6597\u6570\u636E\u7531\u6BCF\u65E5\u5B9A\u65F6\u4EFB\u52A1\u8BA1\u7B97\u3002\u5982\u4E3A\u7A7A\uFF0C\u8BF7\u68C0\u67E5\u7CFB\u7EDF > \u5065\u5EB7\u72B6\u6001\u4E2D\u7684\u5B9A\u65F6\u4EFB\u52A1\u3002",

  // ─── Trend Card ───
  "trend.up": "\u2191",
  "trend.down": "\u2193",
  "trend.flat": "\u2014",

  // ─── Growth Trend Chart ───
  "growth_trend.title": "\u589E\u957F\u8D8B\u52BF (30 \u5929)",
  "growth_trend.chart_label":
    "\u589E\u957F\u8D8B\u52BF\u56FE\uFF0C\u663E\u793A DAU \u548C\u65B0\u7528\u6237",
  "growth_trend.chart_title": "\u589E\u957F\u8D8B\u52BF",
  "growth_trend.dau": "DAU",
  "growth_trend.new_users": "\u65B0\u7528\u6237",

  // ─── Suggestions ───
  "suggestions.title": "\u5EFA\u8BAE",
  "suggestions.loading": "\u52A0\u8F7D\u5EFA\u8BAE\u4E2D...",
  "suggestions.ops": "\u8FD0\u7EF4\u5EFA\u8BAE",
  "suggestions.product": "\u4EA7\u54C1\u5EFA\u8BAE",
  "suggestions.no_suggestions": "\u6682\u65E0\u5EFA\u8BAE",

  // ─── Confirm Dialog ───
  "confirm.reason_label":
    "\u539F\u56E0\uFF08\u6700\u5C11 {{min}} \u4E2A\u5B57\u7B26\uFF09",
  "confirm.reason_placeholder":
    "\u8BF7\u8BF4\u660E\u6B64\u64CD\u4F5C\u7684\u5FC5\u8981\u6027...",
  "confirm.chars_remaining_one": "\u8FD8\u9700 {{count}} \u4E2A\u5B57\u7B26",
  "confirm.chars_remaining_other": "\u8FD8\u9700 {{count}} \u4E2A\u5B57\u7B26",

  // ─── Pagination (DataTable) ───
  "pagination.prev": "\u4E0A\u4E00\u9875",
  "pagination.next": "\u4E0B\u4E00\u9875",

  // ─── Table (TableParts) ───
  "table.loading": "\u52A0\u8F7D\u4E2D...",

  // ─── Global Filters ───
  "filters.platform": "\u5E73\u53F0",
  "filters.country": "\u56FD\u5BB6",
  "filters.language": "\u8BED\u8A00",
  "filters.all_platforms": "\u6240\u6709\u5E73\u53F0",
  "filters.all_countries": "\u6240\u6709\u56FD\u5BB6",
  "filters.all_languages": "\u6240\u6709\u8BED\u8A00",
  "filters.platform_ios": "iOS",
  "filters.platform_ipados": "iPadOS",
  "filters.platform_android": "Android",
  "filters.platform_macos": "macOS",
  "filters.platform_windows": "Windows",
  "filters.platform_admin": "\u7BA1\u7406\u540E\u53F0",

  // ─── Not Found ───
  "not_found.title": "404",
  "not_found.text": "\u9875\u9762\u672A\u627E\u5230",
  "not_found.back": "\u8FD4\u56DE\u4EEA\u8868\u76D8",

  // ─── Placeholder ───
  "placeholder.management": "\u7BA1\u7406",
  "placeholder.wave2":
    "\u6B64\u9875\u9762\u5C06\u5728\u7B2C\u4E8C\u6CE2\u5B9E\u73B0\u3002",

  // ─── Users ───
  "users.title": "\u7528\u6237",
  "users.description": "\u7BA1\u7406\u7528\u6237\u8D26\u53F7",
  "users.search_placeholder":
    "\u6309\u540D\u79F0\u3001\u90AE\u7BB1\u6216 ID \u641C\u7D22...",
  "users.all_status": "\u6240\u6709\u72B6\u6001",
  "users.all_plans": "\u6240\u6709\u65B9\u6848",
  "users.status_active": "\u6D3B\u8DC3",
  "users.status_frozen": "\u5DF2\u51BB\u7ED3",
  "users.status_deactivated": "\u5DF2\u505C\u7528",
  "users.plan_free": "\u514D\u8D39",
  "users.plan_pro": "Pro",
  "users.plan_premium": "Premium",
  "users.plan_max": "Max",
  "users.sort_by": "\u6309 {{label}} \u6392\u5E8F",
  "users.no_users_found": "\u672A\u627E\u5230\u7528\u6237\u3002",
  "users.loading": "\u52A0\u8F7D\u4E2D...",
  "users.col_name": "\u540D\u79F0",
  "users.col_email": "\u90AE\u7BB1",
  "users.col_custom_id": "\u81EA\u5B9A\u4E49 ID",
  "users.col_plan": "\u65B9\u6848",
  "users.col_tokens": "Token",
  "users.col_storage": "\u5B58\u50A8",
  "users.col_status": "\u72B6\u6001",
  "users.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "users.page_info":
    "{{total}} \u4E2A\u7528\u6237 \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── User Detail ───
  "user_detail.loading": "\u52A0\u8F7D\u4E2D...",
  "user_detail.not_found": "\u672A\u627E\u5230\u7528\u6237\u3002",
  "user_detail.failed_to_load": "\u52A0\u8F7D\u7528\u6237\u5931\u8D25",
  "user_detail.deactivated": "\u5DF2\u505C\u7528",
  "user_detail.issue_warning": "发出警告",
  "user_detail.freeze_account": "\u51BB\u7ED3\u8D26\u53F7",
  "user_detail.unfreeze_account": "\u89E3\u51BB\u8D26\u53F7",
  "user_detail.suspend_account": "暂停账号",
  "user_detail.deactivate_account": "停用账号",
  "user_detail.terminate_account": "终止账号",
  "user_detail.freeze_title": "\u51BB\u7ED3\u8D26\u53F7",
  "user_detail.unfreeze_title": "\u89E3\u51BB\u8D26\u53F7",
  "user_detail.freeze_desc":
    "\u8FD9\u5C06\u7ACB\u5373\u64A4\u9500\u6240\u6709\u4F1A\u8BDD\u5E76\u65AD\u5F00\u7528\u6237\u8FDE\u63A5\u3002",
  "user_detail.unfreeze_desc":
    "\u8FD9\u5C06\u6062\u590D\u7528\u6237\u7684\u8BBF\u95EE\u6743\u9650\u3002\u7528\u6237\u9700\u8981\u91CD\u65B0\u767B\u5F55\u3002",
  "user_detail.user_id": "\u7528\u6237 ID",
  "user_detail.custom_id": "\u81EA\u5B9A\u4E49 ID",
  "user_detail.status": "\u72B6\u6001",
  "user_detail.created": "\u521B\u5EFA\u65F6\u95F4",
  "user_detail.tab_overview": "\u6982\u89C8",
  "user_detail.tab_summary_jobs": "\u6458\u8981\u4EFB\u52A1",
  "user_detail.tab_audit": "\u5BA1\u8BA1",
  "user_detail.tab_billing": "\u8D26\u5355",
  "user_detail.plan": "\u65B9\u6848",
  "user_detail.token_balance": "Token \u4F59\u989D",
  "user_detail.storage": "\u5B58\u50A8",
  "user_detail.devices": "\u8BBE\u5907",
  "user_detail.no_summary_jobs": "\u65E0\u6458\u8981\u4EFB\u52A1\u3002",
  "user_detail.no_audit_records": "\u65E0\u5BA1\u8BA1\u8BB0\u5F55\u3002",
  "user_detail.no_billing_events": "\u65E0\u8D26\u5355\u4E8B\u4EF6\u3002",
  "user_detail.col_status": "\u72B6\u6001",
  "user_detail.col_target": "\u76EE\u6807",
  "user_detail.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "user_detail.col_action": "\u64CD\u4F5C",
  "user_detail.col_type": "\u7C7B\u578B",
  "user_detail.col_amount": "\u91D1\u989D",
  "user_lifecycle.optional": "可选",
  "user_lifecycle.field.reason": "原因",
  "user_lifecycle.field.policy_section": "政策条款",
  "user_lifecycle.field.incident_summary": "事件摘要",
  "user_lifecycle.field.suspension_end": "暂停结束时间",
  "user_lifecycle.field.appeal_deadline": "申诉截止时间",
  "user_lifecycle.field.data_export_url": "数据导出链接",
  "user_lifecycle.deactivate.title": "停用账号",
  "user_lifecycle.deactivate.description":
    "停用 {{name}} 并在审计后撤销账号访问。",
  "user_lifecycle.deactivate.confirm": "停用",
  "user_lifecycle.issue-warning.title": "发出警告",
  "user_lifecycle.issue-warning.description":
    "向 {{name}} 发送政策警告，不改变账号访问权限。",
  "user_lifecycle.issue-warning.confirm": "发送警告",
  "user_lifecycle.suspend.title": "暂停账号",
  "user_lifecycle.suspend.description": "将 {{name}} 暂停到指定结束时间。",
  "user_lifecycle.suspend.confirm": "暂停",
  "user_lifecycle.terminate.title": "终止账号",
  "user_lifecycle.terminate.description": "确认申诉和导出信息后终止 {{name}}。",
  "user_lifecycle.terminate.confirm": "终止",

  // ─── Agents ───
  "agents.title": "Agent",
  "agents.description": "Agent \u6CBB\u7406\u7BA1\u7406",
  "agents.tab_list": "Agent",
  "agents.tab_reports": "\u4E3E\u62A5",
  "agents.search_placeholder":
    "\u6309\u540D\u79F0\u6216\u521B\u5EFA\u8005\u641C\u7D22...",
  "agents.status_filter": "\u6309\u6CBB\u7406\u72B6\u6001\u7B5B\u9009",
  "agents.all_status": "\u6240\u6709\u72B6\u6001",
  "agents.no_agents_found": "\u672A\u627E\u5230 Agent\u3002",
  "agents.loading": "\u52A0\u8F7D\u4E2D...",
  "agents.col_name": "\u540D\u79F0",
  "agents.col_creator": "\u521B\u5EFA\u8005",
  "agents.col_connection": "\u8FDE\u63A5",
  "agents.col_status": "\u72B6\u6001",
  "agents.col_risk": "\u98CE\u9669",
  "agents.col_reports": "\u4E3E\u62A5",
  "agents.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "agents.failed_to_load": "\u52A0\u8F7D Agent \u5931\u8D25",
  "agent_reports.agent_id_placeholder": "\u6309 agent_id \u7B5B\u9009",
  "agent_reports.type_filter": "\u6309\u4E3E\u62A5\u7C7B\u578B\u7B5B\u9009",
  "agent_reports.type_all": "\u5168\u90E8\u4E3E\u62A5\u7C7B\u578B",
  "agent_reports.total": "{{total}} \u6761\u4E3E\u62A5",
  "agent_reports.empty": "\u672A\u627E\u5230 Agent \u4E3E\u62A5\u3002",
  "agent_reports.empty_value": "\u65E0",
  "agent_reports.failed": "\u52A0\u8F7D Agent \u4E3E\u62A5\u5931\u8D25",
  "agent_reports.unknown_name": "\u672A\u77E5",
  "agent_reports.col_report": "\u4E3E\u62A5",
  "agent_reports.col_agent": "Agent",
  "agent_reports.col_reporter": "\u4E3E\u62A5\u4EBA",
  "agent_reports.col_type": "\u7C7B\u578B",
  "agent_reports.col_message": "\u6D88\u606F",
  "agent_reports.col_description": "\u63CF\u8FF0",
  "agent_reports.type.credential_phishing": "\u51ED\u636E\u9493\u9C7C",
  "agent_reports.type.system_impersonation": "\u7CFB\u7EDF\u4EFF\u5192",
  "agent_reports.type.spam": "\u5783\u573E\u4FE1\u606F",
  "agent_reports.type.unauthorized_collection":
    "\u672A\u6388\u6743\u6536\u96C6",
  "agent_reports.type.other": "\u5176\u4ED6",

  // ─── Agent Reviews ───
  "agent_reviews.title": "Agent 审核",
  "agent_reviews.description": "审核公开 Agent 上架申请",
  "agent_reviews.failed_to_load": "加载 Agent 审核失败",
  "agent_reviews.action_failed": "审核操作失败",
  "agent_reviews.empty": "未找到上架审核。",
  "agent_reviews.status_filter": "按审核状态筛选",
  "agent_reviews.col_agent": "Agent",
  "agent_reviews.col_creator": "创建者",
  "agent_reviews.col_version": "版本",
  "agent_reviews.col_status": "审核状态",
  "agent_reviews.col_reasons": "原因",
  "agent_reviews.col_submitted": "提交时间",
  "agent_reviews.approve": "通过",
  "agent_reviews.reject": "拒绝",
  "agent_reviews.approve_title": "通过 Agent 上架",
  "agent_reviews.reject_title": "拒绝 Agent 上架",
  "agent_reviews.approve_desc":
    "该操作会把提交的 Agent 版本作为免费公开上架发布到发现页。",
  "agent_reviews.reject_desc":
    "该操作会拒绝提交的 Agent 版本。请为创建者填写审核备注。",
  "agent_reviews.status.submitted": "已提交",
  "agent_reviews.status.auto_check_failed": "自动检查失败",
  "agent_reviews.status.human_review": "人工审核",
  "agent_reviews.status.approved": "已通过",
  "agent_reviews.status.rejected": "已拒绝",
  "agent_reviews.status.withdrawn": "已撤回",

  // ─── Agent Detail ───
  "agent_detail.created_by": "\u521B\u5EFA\u8005: {{name}}",
  "agent_detail.loading": "\u52A0\u8F7D\u4E2D...",
  "agent_detail.not_found": "\u672A\u627E\u5230 Agent\u3002",
  "agent_detail.failed_to_load": "\u52A0\u8F7D Agent \u5931\u8D25",
  "agent_detail.banned": "\u5DF2\u5C01\u7981",
  "agent_detail.restrict_agent": "\u9650\u5236 Agent",
  "agent_detail.restore_agent": "\u6062\u590D Agent",
  "agent_detail.unpublish_agent": "\u4E0B\u67B6\u5217\u8868",
  "agent_detail.ban_agent": "\u5C01\u7981 Agent",
  "agent_detail.rotate_identity": "\u8F6E\u6362\u8EAB\u4EFD\u5BC6\u94A5",
  "agent_detail.activate_paid_access": "\u542F\u7528\u4ED8\u8D39\u8BBF\u95EE",
  "agent_detail.restrict_title": "\u9650\u5236 Agent",
  "agent_detail.restore_title": "\u6062\u590D Agent",
  "agent_detail.unpublish_title": "\u4E0B\u67B6 Agent \u5217\u8868",
  "agent_detail.ban_title": "\u5C01\u7981 Agent",
  "agent_detail.restrict_desc":
    "\u8FD9\u5C06\u9650\u5236 Agent \u8FD0\u884C\u3002\u73B0\u6709\u8FDE\u63A5\u5C06\u53D7\u5F71\u54CD\u3002",
  "agent_detail.restore_desc":
    "\u8FD9\u5C06\u6062\u590D Agent \u4E3A\u6D3B\u52A8\u72B6\u6001\u3002",
  "agent_detail.unpublish_desc":
    "\u8FD9\u4F1A\u5C06 Agent \u4ECE\u53D1\u73B0\u9875\u4E0B\u67B6\uFF0C\u5E76\u5173\u95ED\u4ED8\u8D39\u53D8\u73B0\u3002\u4E0D\u4F1A\u5C06\u79C1\u6709\u6216\u53D7\u4FDD\u62A4\u4F7F\u7528\u63D0\u5347\u4E3A\u516C\u5F00\u3002",
  "agent_detail.ban_desc":
    "\u6C38\u4E45\u5C01\u7981 Agent {{name}} ({{id}})\u3002\u4F1A\u901A\u77E5 Creator\uFF0C\u51BB\u7ED3\u6240\u6709\u76F8\u5173\u5BF9\u8BDD\uFF0C\u5E76\u5C06\u64CD\u4F5C\u8BB0\u5165 audit_records\u3002\u4E25\u91CD\u7A0B\u5EA6\u9AD8\u4E8E\u201C\u9650\u5236\u201D\uFF0C\u9002\u7528\u4E8E\u8FDD\u53CD\u670D\u52A1\u6761\u6B3E\u573A\u666F\u3002",
  "agent_detail.agent_id": "Agent ID",
  "agent_detail.status": "\u72B6\u6001",
  "agent_detail.listing_status": "\u5217\u8868\u72B6\u6001",
  "agent_detail.monetization_status": "\u53D8\u73B0\u72B6\u6001",
  "agent_detail.connection": "\u8FDE\u63A5",
  "agent_detail.risk_score": "\u98CE\u9669\u5206",
  "agent_detail.reports": "\u4E3E\u62A5",
  "agent_detail.description": "\u63CF\u8FF0",
  "agent_detail.created": "\u521B\u5EFA\u65F6\u95F4",
  "agent_detail.h2a_active": "\u6D3B\u52A8",
  "agent_detail.h2a_suspended": "\u5DF2\u6682\u505C",
  "agent_detail.h2a_terminated": "\u5DF2\u7EC8\u6B62",
  "agent_detail.tab_overview": "\u6982\u89C8",
  "agent_detail.tab_governance_history": "\u6CBB\u7406\u5386\u53F2",
  "agent_detail.tab_reports": "\u4E3E\u62A5",
  "agent_detail.connection_mode": "\u8FDE\u63A5\u6A21\u5F0F",
  "agent_detail.report_count": "\u4E3E\u62A5\u6570",
  "agent_detail.last_updated": "\u6700\u540E\u66F4\u65B0",
  "agent_detail.no_governance_history": "\u65E0\u6CBB\u7406\u5386\u53F2\u3002",
  "agent_detail.no_reports": "\u65E0\u4E3E\u62A5\u3002",
  "agent_detail.col_reporter": "\u4E3E\u62A5\u4EBA",
  "agent_detail.col_reason": "\u539F\u56E0",
  "agent_detail.col_status": "\u72B6\u6001",
  "agent_detail.col_date": "\u65E5\u671F",
  "agent_paid_access.title": "\u542F\u7528\u4ED8\u8D39\u8BBF\u95EE",
  "agent_paid_access.description":
    "\u786E\u8BA4 {{name}} \u7684\u6743\u76CA\u4EA4\u4ED8\u8DEF\u5F84\u5DF2\u5C31\u7EEA\u540E\uFF0C\u5C06\u5176\u4ECE\u4ED8\u8D39\u5BA1\u6838\u72B6\u6001\u63A8\u8FDB\u5230 paid_active\u3002",
  "agent_paid_access.reason": "\u5BA1\u8BA1\u539F\u56E0",
  "agent_paid_access.entitlement_path_ready":
    "\u6743\u76CA\u4EA4\u4ED8\u8DEF\u5F84\u5DF2\u5C31\u7EEA\u5E76\u5B8C\u6210\u9A8C\u8BC1",
  "agent_paid_access.confirm": "\u542F\u7528\u4ED8\u8D39\u8BBF\u95EE",
  "agent_identity_rotation.title":
    "\u8F6E\u6362 Agent \u8EAB\u4EFD\u5BC6\u94A5",
  "agent_identity_rotation.description":
    "\u66FF\u6362 {{name}} \u5BF9\u5916\u516C\u544A\u7684\u8EAB\u4EFD\u5BC6\u94A5\u675F\u3002\u6B64\u64CD\u4F5C\u9700\u8981\u5B8C\u6574 prekey bundle\uFF0C\u5E76\u5199\u5165\u7BA1\u7406\u5458\u5BA1\u8BA1\u8BB0\u5F55\u3002",
  "agent_identity_rotation.confirm": "\u8F6E\u6362\u8EAB\u4EFD\u5BC6\u94A5",
  "agent_identity_rotation.new_ik_x25519_public_key": "X25519 identity key",
  "agent_identity_rotation.new_ik_ed25519_public_key": "Ed25519 identity key",
  "agent_identity_rotation.new_spk_id": "Signed prekey ID",
  "agent_identity_rotation.new_spk_public_key": "Signed prekey",
  "agent_identity_rotation.new_spk_signature": "Signed prekey \u7B7E\u540D",
  "agent_identity_rotation.new_spk_expires_at":
    "Signed prekey \u8FC7\u671F\u65F6\u95F4",
  "agent_identity_rotation.identity_binding_proof": "Identity binding proof",
  "agent_identity_rotation.justification": "\u64CD\u4F5C\u7406\u7531",

  // ─── Grants ───
  "grants.title": "Token \u6388\u6743",
  "grants.description": "\u6570\u636E\u8BBF\u95EE\u6388\u6743",
  "grants.placeholder_user_id": "\u7528\u6237 ID",
  "grants.placeholder_agent_id": "Agent ID",
  "grants.placeholder_scope_type": "\u8303\u56F4\u7C7B\u578B",
  "grants.placeholder_status": "\u72B6\u6001",
  "grants.no_grants_found": "\u672A\u627E\u5230\u6388\u6743",
  "grants.col_grant_id": "\u6388\u6743 ID",
  "grants.col_user": "\u7528\u6237",
  "grants.col_agent": "Agent",
  "grants.col_scope": "\u8303\u56F4",
  "grants.col_expires": "\u8FC7\u671F",
  "grants.col_status": "\u72B6\u6001",
  "grants.never": "\u6C38\u4E0D",
  "grants.loading_detail": "\u52A0\u8F7D\u8BE6\u60C5...",
  "grants.scope_value": "\u8303\u56F4\u503C:",
  "grants.created": "\u521B\u5EFA\u65F6\u95F4:",
  "grants.summary_jobs": "\u6458\u8981\u4EFB\u52A1",
  "grants.no_summary_jobs": "\u65E0\u5173\u8054\u6458\u8981\u4EFB\u52A1",

  // ─── Audit ───
  "audit.title": "\u5BA1\u8BA1\u65E5\u5FD7",
  "audit.description": "\u7BA1\u7406\u64CD\u4F5C\u5386\u53F2",
  "audit.placeholder_action": "\u64CD\u4F5C",
  "audit.placeholder_actor_id": "\u64CD\u4F5C\u4EBA ID",
  "audit.placeholder_target_id": "\u76EE\u6807 ID",
  "audit.start_date": "\u5F00\u59CB\u65E5\u671F",
  "audit.end_date": "\u7ED3\u675F\u65E5\u671F",
  "audit.col_action": "\u64CD\u4F5C",
  "audit.col_actor": "\u64CD\u4F5C\u4EBA",
  "audit.col_target": "\u76EE\u6807",
  "audit.col_metadata": "\u5143\u6570\u636E",
  "audit.col_date": "\u65E5\u671F",
  "audit.no_records_found": "\u672A\u627E\u5230\u5BA1\u8BA1\u8BB0\u5F55",

  // ─── Metrics Layout ───
  "metrics.title": "\u6307\u6807",
  "metrics.description": "\u5206\u6790\u4E0E\u6027\u80FD\u6570\u636E",
  "metrics.tab_growth": "\u589E\u957F",
  "metrics.tab_funnel": "\u6F0F\u6597",
  "metrics.tab_revenue": "\u8425\u6536",
  "metrics.tab_system": "\u7CFB\u7EDF",
  "metrics.tab_behavior": "\u884C\u4E3A",
  "metrics.tab_messages": "\u6D88\u606F",
  "metrics.tab_feature_value": "\u529F\u80FD\u4EF7\u503C",
  "metrics.tab_segments": "\u5206\u7FA4",
  "metrics.tab_cohort": "\u7FA4\u7EC4",

  // ─── Growth Tab ───
  "growth.avg_dau": "\u5E73\u5747 DAU",
  "growth.new_users": "\u65B0\u7528\u6237",
  "growth.messages": "\u6D88\u606F",
  "growth.summary_requests": "\u6458\u8981\u8BF7\u6C42",
  "growth.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "growth.col_date": "\u65E5\u671F",
  "growth.col_dau": "DAU",
  "growth.col_new_users": "\u65B0\u7528\u6237",
  "growth.col_messages": "\u6D88\u606F",
  "growth.col_summary_req": "\u6458\u8981\u8BF7\u6C42",

  // ─── Funnel Tab ───
  "funnel.funnel_steps": "\u6F0F\u6597\u6B65\u9AA4",
  "funnel.no_funnel_data": "\u65E0\u6F0F\u6597\u6570\u636E",
  "funnel.label_funnel": "\u6F0F\u6597",
  "funnel.activation": "\u6FC0\u6D3B",
  "funnel.content_loop": "\u5185\u5BB9\u5FAA\u73AF",
  "funnel.monetization": "\u53D8\u73B0",

  // ─── Revenue Tab ───
  "revenue.mrr": "MRR",
  "revenue.paid_users": "\u4ED8\u8D39\u7528\u6237",
  "revenue.checkouts": "\u7ED3\u8D26",
  "revenue.topups": "\u5145\u503C",
  "revenue.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "revenue.col_date": "\u65E5\u671F",
  "revenue.col_mrr": "MRR",
  "revenue.col_paid_users": "\u4ED8\u8D39\u7528\u6237",
  "revenue.col_checkouts": "\u7ED3\u8D26",
  "revenue.col_topups": "\u5145\u503C",

  // ─── System Tab ───
  "system_tab.summary_requests": "\u6458\u8981\u8BF7\u6C42",
  "system_tab.success_rate": "\u6210\u529F\u7387",
  "system_tab.storage": "\u5B58\u50A8",
  "system_tab.webhook_failures": "Webhook \u5931\u8D25",
  "system_tab.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "system_tab.col_date": "\u65E5\u671F",
  "system_tab.col_summary_req": "\u6458\u8981\u8BF7\u6C42",
  "system_tab.col_success": "\u6210\u529F",
  "system_tab.col_failed": "\u5931\u8D25",
  "system_tab.col_storage": "\u5B58\u50A8",
  "system_tab.col_wh_failures": "WH \u5931\u8D25",

  // ─── Behavior Tab ───
  "behavior.sessions_per_user": "\u4F1A\u8BDD / \u7528\u6237 / \u5929",
  "behavior.messages_per_user": "\u6D88\u606F / \u7528\u6237 / \u5929",
  "behavior.summaries_per_user": "\u6458\u8981 / \u7528\u6237 / \u5929",
  "behavior.bookmarks_per_user": "\u4E66\u7B7E / \u7528\u6237 / \u5929",
  "behavior.shares_per_user": "\u5206\u4EAB / \u7528\u6237 / \u5929",
  "behavior.agent_usage_rate": "Agent \u4F7F\u7528\u7387",
  "behavior.retention_rate": "\u7559\u5B58\u7387",
  "behavior.message_breakdown": "\u6D88\u606F\u5206\u5E03",
  "behavior.human_messages": "\u4EBA\u7C7B\u6D88\u606F",
  "behavior.agent_messages": "Agent \u6D88\u606F",
  "behavior.group_messages": "\u7FA4\u7EC4\u6D88\u606F",
  "behavior.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "behavior.col_date": "\u65E5\u671F",
  "behavior.col_sessions": "\u4F1A\u8BDD/U",
  "behavior.col_msgs": "\u6D88\u606F/U",
  "behavior.col_summaries": "\u6458\u8981/U",
  "behavior.col_bookmarks": "\u4E66\u7B7E/U",
  "behavior.col_shares": "\u5206\u4EAB/U",
  "behavior.col_agent_rate": "Agent \u7387",
  "behavior.col_retention": "\u7559\u5B58",

  // ─── Feature Value Tab ───
  "feature_value.title": "\u529F\u80FD\u4EF7\u503C\u5206\u6790",
  "feature_value.col_feature": "\u529F\u80FD",
  "feature_value.col_exposure": "\u66DD\u5149",
  "feature_value.col_adoption": "\u91C7\u7528",
  "feature_value.col_repeat": "\u91CD\u590D",
  "feature_value.col_retention_lift": "\u7559\u5B58\u63D0\u5347",
  "feature_value.col_status": "\u72B6\u6001",
  "feature_value.core_feature": "\u6838\u5FC3\u529F\u80FD",
  "feature_value.exposed_but_weak": "\u66DD\u5149\u4F46\u5F31",
  "feature_value.used_but_shallow": "\u4F7F\u7528\u4F46\u6D45",
  "feature_value.neutral": "\u4E2D\u6027",

  // ─── Segment Tab ───
  "segment.distribution": "\u5206\u7FA4\u5206\u5E03",
  "segment.no_data": "\u8BE5\u65E5\u671F\u65E0\u5206\u7FA4\u6570\u636E",
  "segment.users_title": "\u7528\u6237",
  "segment.power_user": "\u8D85\u7EA7\u7528\u6237",
  "segment.builder": "\u521B\u5EFA\u8005",
  "segment.organizer": "\u7EC4\u7EC7\u8005",
  "segment.reader": "\u9605\u8BFB\u8005",
  "segment.chat_only": "\u4EC5\u804A\u5929",
  "segment.col_user_id": "\u7528\u6237 ID",
  "segment.col_messages": "\u6D88\u606F",
  "segment.col_summaries": "\u6458\u8981",
  "segment.col_deliveries": "\u4EA4\u4ED8\u7269",
  "segment.col_shares": "\u5206\u4EAB",
  "segment.col_favorited": "\u6536\u85CF",
  "segment.no_users": "\u8BE5\u5206\u7FA4\u65E0\u7528\u6237",

  // ─── Cohort Tab ───
  "cohort.cohorts": "\u7FA4\u7EC4",
  "cohort.total_users": "\u603B\u7528\u6237",
  "cohort.avg_week1_retention": "\u7B2C1\u5468\u5E73\u5747\u7559\u5B58",
  "cohort.avg_week4_retention": "\u7B2C4\u5468\u5E73\u5747\u7559\u5B58",
  "cohort.retention_matrix": "\u7559\u5B58\u77E9\u9635",
  "cohort.col_cohort_week": "\u7FA4\u7EC4\u5468",
  "cohort.col_users": "\u7528\u6237",
  "cohort.no_cohort_data": "\u65E0\u7FA4\u7EC4\u6570\u636E",

  // ─── Billing Page ───
  "billing.title": "\u8D26\u5355",
  "billing.description":
    "\u7528\u6237\u8D26\u5355\u67E5\u8BE2\u4E0E\u64CD\u4F5C",
  "billing.search_placeholder": "\u8F93\u5165 user_id...",
  "billing.user": "\u7528\u6237",
  "billing.plan": "\u65B9\u6848",
  "billing.status": "\u72B6\u6001",
  "billing.token_balance": "Token \u4F59\u989D",
  "billing.subscription_usage": "\u8BA2\u9605\u7528\u91CF",
  "billing.topup_remaining": "\u5145\u503C\u5269\u4F59",
  "billing.grant_tokens": "\u53D1\u653E Token",
  "billing.resync_entitlement": "\u91CD\u65B0\u540C\u6B65\u6743\u76CA",
  "billing.developer_credit": "开发者入账",
  "billing.token_amount_label": "\u53D1\u653E Token \u6570\u91CF:",
  "billing.grant_title": "\u53D1\u653E Token",
  "billing.resync_title": "\u91CD\u65B0\u540C\u6B65\u6743\u76CA",
  "billing.replay_title": "\u91CD\u64AD Webhook",
  "billing.grant_desc":
    "\u5411\u6B64\u7528\u6237\u53D1\u653E {{amount}} \u4E2A Token\u3002",
  "billing.resync_desc":
    "\u4ECE Stripe \u91CD\u65B0\u540C\u6B65\u6743\u76CA\u3002",
  "billing.replay_desc":
    "\u91CD\u64AD\u6B64\u5931\u8D25\u7684 Webhook \u4E8B\u4EF6\u3002",
  "billing.developer_credit_title": "开发者余额入账",
  "billing.developer_credit_desc":
    "为用户 {{userId}} 的开发者余额入账，并记录审计原因。",
  "billing.developer_credit_confirm": "确认入账",
  "billing.developer_credit_amount_minor": "最小货币单位金额",
  "billing.developer_credit_currency": "币种",
  "billing.developer_credit_reason": "原因",
  "billing.tab_user_billing": "用户账单",
  "billing.tab_agent_commerce": "Agent 商业化",
  "billing.agent_pricing_title": "Agent 订阅价格映射",
  "billing.agent_pricing_desc":
    "将已审核的 Agent 订阅 SKU 映射到 Stripe price 和 product。",
  "billing.agent_pricing_sku": "Hashee SKU",
  "billing.agent_pricing_stripe_price": "Stripe Price ID",
  "billing.agent_pricing_stripe_product": "Stripe Product ID",
  "billing.agent_pricing_reason": "原因",
  "billing.agent_pricing_save": "保存映射",
  "billing.agent_pricing_success": "已保存 {{sku}} 的映射。",

  // ─── Billing Tables ───
  "billing_table.token_ledger": "Token \u8D26\u672C",
  "billing_table.col_type": "\u7C7B\u578B",
  "billing_table.col_amount": "\u91D1\u989D",
  "billing_table.col_balance_after": "\u64CD\u4F5C\u540E\u4F59\u989D",
  "billing_table.col_description": "\u63CF\u8FF0",
  "billing_table.col_date": "\u65E5\u671F",
  "billing_table.no_ledger_entries": "\u65E0\u8D26\u672C\u8BB0\u5F55",
  "billing_table.usage_events": "\u7528\u91CF\u4E8B\u4EF6",
  "billing_table.payment_transactions": "\u652F\u4ED8\u4EA4\u6613",
  "billing_table.entitlement_events": "\u6743\u76CA\u4E8B\u4EF6",
  "billing_table.webhook_events": "Webhook \u4E8B\u4EF6",
  "billing_table.col_provider": "\u63D0\u4F9B\u5546",
  "billing_table.col_source": "\u6765\u6E90",
  "billing_table.col_resource": "\u8D44\u6E90",
  "billing_table.col_provider_model": "\u63D0\u4F9B\u5546 / \u6A21\u578B",
  "billing_table.col_units": "\u7528\u91CF",
  "billing_table.col_price_version": "\u4EF7\u683C\u7248\u672C",
  "billing_table.col_finalized": "\u7ED3\u7B97",
  "billing_table.col_sku": "SKU",
  "billing_table.col_transaction": "\u4EA4\u6613",
  "billing_table.col_entitlement": "\u6743\u76CA",
  "billing_table.col_verified": "\u9A8C\u8BC1",
  "billing_table.col_plan": "\u65B9\u6848",
  "billing_table.col_token_delta": "Token \u53D8\u5316",
  "billing_table.col_storage_limit": "\u5B58\u50A8\u4E0A\u9650",
  "billing_table.col_preview_minutes": "\u9884\u89C8\u5206\u949F",
  "billing_table.col_source_transaction": "\u6E90\u4EA4\u6613",
  "billing_table.col_effective": "\u751F\u6548",
  "billing_table.col_event_id": "\u4E8B\u4EF6 ID",
  "billing_table.col_event_type": "\u4E8B\u4EF6\u7C7B\u578B",
  "billing_table.col_status": "\u72B6\u6001",
  "billing_table.col_received": "\u63A5\u6536",
  "billing_table.col_processed": "\u5904\u7406",
  "billing_table.col_action": "\u64CD\u4F5C",
  "billing_table.replay": "\u91CD\u64AD",
  "billing_table.no_usage_events": "\u65E0\u7528\u91CF\u4E8B\u4EF6",
  "billing_table.no_payment_transactions": "\u65E0\u652F\u4ED8\u4EA4\u6613",
  "billing_table.no_entitlement_events": "\u65E0\u6743\u76CA\u4E8B\u4EF6",
  "billing_table.no_webhook_events": "\u65E0 Webhook \u4E8B\u4EF6",

  // ─── Storage Page ───
  "storage.title": "\u5B58\u50A8",
  "storage.description":
    "\u76D1\u63A7\u7528\u6237\u5B58\u50A8\u4F7F\u7528\u4E0E\u540C\u6B65\u72B6\u6001",
  "storage.filter_all": "\u5168\u90E8",
  "storage.filter_over_quota": "\u8D85\u51FA\u914D\u989D",
  "storage.filter_sync_error": "\u540C\u6B65\u9519\u8BEF",
  "storage.no_users_found": "\u672A\u627E\u5230\u7528\u6237\u3002",
  "storage.col_user": "\u7528\u6237",
  "storage.col_used_limit": "\u5DF2\u7528 / \u9650\u989D",
  "storage.col_msg": "\u6D88\u606F",
  "storage.col_media": "\u5A92\u4F53",
  "storage.col_art": "\u4F5C\u54C1",
  "storage.col_kb": "\u77E5\u8BC6\u5E93",
  "storage.col_sync": "\u540C\u6B65",

  // ─── Storage Orphan Audit (Dry-run) ───
  "storage_orphan_audit.title":
    "\u5B58\u50A8\u5B64\u7ACB\u5BF9\u8C61\u5BA1\u8BA1\uFF08\u5E72\u8DD1\uFF09",
  "storage_orphan_audit.description":
    "R2 \u4E2D\u65E0\u5BF9\u5E94 storage_objects \u8BB0\u5F55\u7684\u5BF9\u8C61\u3002\u4EC5\u8BFB\u3002\u6BCF\u5468\u65E5 UTC 07:00 \u8FD0\u884C\u3002",
  "storage_orphan_audit.banner_dry_run":
    "V1.1 \u5E72\u8DD1\u2014\u2014\u4E0D\u4F1A\u81EA\u52A8\u5220\u9664\u3002\u4EC5\u4F9B\u8C03\u67E5\u3002",
  "storage_orphan_audit.no_runs_yet":
    "\u5C1A\u672A\u53D1\u73B0\u5B64\u7ACB\u5BF9\u8C61\u5BA1\u8BA1\u8BB0\u5F55\u3002\u6BCF\u5468\u65E5 UTC 07:00 \u8FD0\u884C\u3002",
  "storage_orphan_audit.latest_run": "\u6700\u8FD1\u4E00\u6B21\u8FD0\u884C",
  "storage_orphan_audit.history": "\u8FD1 30 \u5929\u8FD0\u884C\u8BB0\u5F55",
  "storage_orphan_audit.prefix_breakdown": "\u524D\u7F00 Top N",
  "storage_orphan_audit.no_prefix_data":
    "\u6700\u8FD1\u4E00\u6B21\u8FD0\u884C\u672A\u8BB0\u5F55\u524D\u7F00\u660E\u7EC6\u3002",
  "storage_orphan_audit.no_history_data":
    "\u8FD1 30 \u5929\u5185\u65E0\u5386\u53F2\u8FD0\u884C\u3002",
  "storage_orphan_audit.col_prefix": "\u524D\u7F00",
  "storage_orphan_audit.col_count": "\u5B64\u7ACB\u6570\u91CF",
  "storage_orphan_audit.col_bytes": "\u603B\u5B57\u8282\u6570",
  "storage_orphan_audit.col_run_at": "\u8FD0\u884C\u65F6\u95F4",
  "storage_orphan_audit.col_oldest": "\u6700\u65E9\u5BF9\u8C61",
  "storage_orphan_audit.col_environment": "\u73AF\u5883",
  "storage_orphan_audit.env_prod": "\u751F\u4EA7",
  "storage_orphan_audit.env_nonprod": "\u975E\u751F\u4EA7",
  "storage_orphan_audit.partial_scan_warning":
    "\u90E8\u5206\u626B\u63CF\uFF1Astorage_objects \u8868\u8D85\u51FA 5 \u4E07\u6761\u8BB0\u5F55\u4E0A\u9650\uFF1B\u5B64\u7ACB\u8BA1\u6570\u53EF\u80FD\u504F\u5927\u3002",

  // ─── Storage Detail Panel ───
  "storage_detail.breakdown": "\u660E\u7EC6",
  "storage_detail.failed_to_load": "\u52A0\u8F7D\u8BE6\u60C5\u5931\u8D25\u3002",
  "storage_detail.recalculate": "\u91CD\u65B0\u8BA1\u7B97",
  "storage_detail.run_cleanup": "\u8FD0\u884C\u6E05\u7406",
  "storage_detail.recalculate_title": "\u91CD\u65B0\u8BA1\u7B97\u5B58\u50A8",
  "storage_detail.recalculate_desc":
    "\u8FD9\u5C06\u6839\u636E\u5BF9\u8C61\u5927\u5C0F\u91CD\u65B0\u8BA1\u7B97\u603B\u5B58\u50A8\u4F7F\u7528\u91CF\u3002\u73B0\u6709\u503C\u5C06\u88AB\u8986\u76D6\u3002",
  "storage_detail.cleanup_title": "\u8FD0\u884C\u6E05\u7406",
  "storage_detail.cleanup_desc":
    "\u8FD9\u5C06\u6807\u8BB0\u6240\u6709\u8F6F\u5220\u9664\u5BF9\u8C61\u4E3A\u7269\u7406\u5220\u9664\u3002\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002",
  "storage_detail.tab_trace": "\u8FFD\u6EAF",
  "storage_detail.tab_breakdown": "\u660E\u7EC6",
  "storage_detail.tab_sync": "\u540C\u6B65",
  "storage_detail.no_breakdown": "\u6682\u65E0\u660E\u7EC6\u3002",
  "storage_detail.object_count_bytes":
    "{{count}} \u4E2A\u5BF9\u8C61\uFF0C{{bytes}}",
  "storage_detail.no_recent_changes":
    "\u6682\u65E0\u6700\u8FD1\u5BF9\u8C61\u3002",
  "storage_detail.no_sync_cursors":
    "\u6682\u65E0\u540C\u6B65\u6E38\u6807\u3002",
  "storage_detail.col_object": "\u5BF9\u8C61",
  "storage_detail.col_size": "\u5927\u5C0F",
  "storage_detail.col_state": "\u72B6\u6001",
  "storage_detail.col_trace": "\u6765\u6E90",
  "storage_detail.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "storage_detail.col_device": "\u8BBE\u5907",
  "storage_detail.col_conversation": "\u4F1A\u8BDD",
  "storage_detail.col_last_seq": "\u6700\u540E\u5E8F\u53F7",
  "storage_detail.col_synced_at": "\u540C\u6B65\u65F6\u95F4",
  "storage_detail.trace_unresolved": "\u672A\u89E3\u6790",
  "storage_detail.storage_object_id": "\u5B58\u50A8\u5BF9\u8C61",
  "storage_detail.conversation_id": "\u4F1A\u8BDD",
  "storage_detail.ref_id": "\u5F15\u7528",
  "storage_detail.message_id": "\u6D88\u606F",
  "storage_detail.upload_id": "\u4E0A\u4F20",
  "storage_detail.deleted_at": "\u5DF2\u5220\u9664 {{date}}",
  "storage_detail.source_message_archive": "\u6D88\u606F\u5F52\u6863",
  "storage_detail.source_file_upload": "\u6587\u4EF6\u4E0A\u4F20",
  "storage_detail.source_cloud_preview_session": "Cloud Preview",
  "storage_detail.source_public_space_item": "\u516C\u5F00\u5185\u5BB9",
  "storage_detail.status_pending": "\u7B49\u5F85\u4E2D",
  "storage_detail.status_finalizing": "\u7EC8\u7ED3\u4E2D",
  "storage_detail.status_confirmed": "\u5DF2\u786E\u8BA4",
  "storage_detail.status_aborted": "\u5DF2\u4E2D\u6B62",
  "storage_detail.status_pending_delete": "\u5F85\u5220\u9664",
  "storage_detail.status_deleted": "\u5DF2\u5220\u9664",
  "storage_detail.recalculated_message":
    "\u91CD\u65B0\u8BA1\u7B97\uFF1A{{previous}} -> {{current}}",
  "storage_detail.cleanup_message":
    "\u6E05\u7406\uFF1A\u5DF2\u6807\u8BB0 {{count}} \u4E2A\u5BF9\u8C61",

  // ─── Summary Jobs Page ───
  "summary_jobs.title": "\u6458\u8981\u4EFB\u52A1",
  "summary_jobs.description":
    "\u76D1\u63A7 AI \u6458\u8981\u4EFB\u52A1\u5E76\u91CD\u8BD5\u5931\u8D25",
  "summary_jobs.filter_all": "\u5168\u90E8",
  "summary_jobs.filter_pending": "\u7B49\u5F85\u4E2D",
  "summary_jobs.filter_running": "\u8FD0\u884C\u4E2D",
  "summary_jobs.filter_completed": "\u5DF2\u5B8C\u6210",
  "summary_jobs.filter_failed": "\u5931\u8D25",
  "summary_jobs.user_id_placeholder": "\u6309\u7528\u6237 ID \u7B5B\u9009...",
  "summary_jobs.no_jobs_found": "\u672A\u627E\u5230\u4EFB\u52A1\u3002",
  "summary_jobs.col_target": "\u76EE\u6807",
  "summary_jobs.col_user": "\u7528\u6237",
  "summary_jobs.col_status": "\u72B6\u6001",
  "summary_jobs.col_model": "\u6A21\u578B",
  "summary_jobs.col_tokens_in": "Tokens \u8F93\u5165",
  "summary_jobs.col_tokens_out": "Tokens \u8F93\u51FA",
  "summary_jobs.col_created": "\u521B\u5EFA\u65F6\u95F4",

  // ─── Summary Job Detail Panel ───
  "summary_job_detail.failed_to_load":
    "\u52A0\u8F7D\u8BE6\u60C5\u5931\u8D25\u3002",
  "summary_job_detail.error": "\u9519\u8BEF",
  "summary_job_detail.grant": "\u6388\u6743",
  "summary_job_detail.scope": "\u8303\u56F4",
  "summary_job_detail.expires": "\u8FC7\u671F",
  "summary_job_detail.thread": "\u7EBF\u7A0B",
  "summary_job_detail.thread_status": "\u72B6\u6001",
  "summary_job_detail.preview": "\u9884\u89C8",
  "summary_job_detail.retry_job": "\u91CD\u8BD5\u4EFB\u52A1",
  "summary_job_detail.retry_title": "\u91CD\u8BD5\u6458\u8981\u4EFB\u52A1",
  "summary_job_detail.retry_desc":
    "\u8FD9\u5C06\u4F7F\u7528\u76F8\u540C\u76EE\u6807\u521B\u5EFA\u65B0\u7684\u7B49\u5F85\u4EFB\u52A1\u3002\u5931\u8D25\u7684\u4EFB\u52A1\u8BB0\u5F55\u5C06\u4FDD\u7559\u4EE5\u4F9B\u5BA1\u8BA1\u3002",

  // ─── Deliveries Page ───
  "deliveries.title": "\u4EA4\u4ED8\u7269",
  "deliveries.description": "\u7BA1\u7406\u4EA4\u4ED8\u5185\u5BB9",
  "deliveries.all_types": "\u6240\u6709\u7C7B\u578B",
  "deliveries.user_id_placeholder": "\u6309\u7528\u6237 ID \u7B5B\u9009...",
  "deliveries.no_deliveries_found":
    "\u672A\u627E\u5230\u4EA4\u4ED8\u7269\u3002",
  "deliveries.loading_detail": "\u52A0\u8F7D\u8BE6\u60C5...",
  "deliveries.col_title": "\u6807\u9898",
  "deliveries.col_type": "\u7C7B\u578B",
  "deliveries.col_user": "\u7528\u6237",
  "deliveries.col_conversation": "\u4F1A\u8BDD",
  "deliveries.col_pinned": "\u7F6E\u9876",
  "deliveries.col_hidden": "\u9690\u85CF",
  "deliveries.col_deleted": "\u5DF2\u5220\u9664",
  "deliveries.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "deliveries.detail_user": "\u7528\u6237",
  "deliveries.detail_conversation": "\u4F1A\u8BDD",
  "deliveries.detail_mime": "MIME",
  "deliveries.detail_size": "\u5927\u5C0F",
  "deliveries.detail_updated": "\u66F4\u65B0\u65F6\u95F4",
  "deliveries.reindex": "\u91CD\u5EFA\u7D22\u5F15",
  "deliveries.unhide": "\u53D6\u6D88\u9690\u85CF",
  "deliveries.unpin": "\u53D6\u6D88\u7F6E\u9876",
  "deliveries.reindex_title": "\u91CD\u5EFA\u4EA4\u4ED8\u7269\u7D22\u5F15",
  "deliveries.unhide_title": "\u53D6\u6D88\u9690\u85CF\u4EA4\u4ED8\u7269",
  "deliveries.unpin_title": "\u53D6\u6D88\u7F6E\u9876\u4EA4\u4ED8\u7269",
  "deliveries.reindex_desc":
    "\u8FD9\u5C06\u89E6\u53D1\u4EA4\u4ED8\u5185\u5BB9\u7684\u91CD\u65B0\u7D22\u5F15\u3002",
  "deliveries.unhide_desc":
    "\u8FD9\u5C06\u4F7F\u4EA4\u4ED8\u7269\u5BF9\u7528\u6237\u91CD\u65B0\u53EF\u89C1\u3002",
  "deliveries.unpin_desc":
    "\u8FD9\u5C06\u79FB\u9664\u4EA4\u4ED8\u7269\u7684\u7F6E\u9876\u3002",

  // ─── Integrations Page ───
  "integrations.title": "\u96C6\u6210",
  "integrations.description": "SDK\u3001\u63D2\u4EF6\u548C CLI \u6307\u6807",
  "integrations.tab_sdk": "SDK",
  "integrations.tab_openclaw": "OpenClaw",
  "integrations.tab_claude_code": "Claude Code \u63D2\u4EF6",
  "integrations.tab_codex": "Codex \u63D2\u4EF6",
  "integrations.tab_cli": "CLI",
  "integrations.active_accounts": "\u6D3B\u8DC3\u8D26\u53F7",
  "integrations.active_agents": "\u6D3B\u8DC3 Agent",
  "integrations.messages": "\u6D88\u606F",
  "integrations.deliveries": "\u4EA4\u4ED8\u7269",
  "integrations.errors": "\u9519\u8BEF",
  "integrations.disconnects": "\u65AD\u5F00\u8FDE\u63A5",
  "integrations.version_distribution": "\u7248\u672C\u5206\u5E03",
  "integrations.col_version": "\u7248\u672C",
  "integrations.col_count": "\u6570\u91CF",
  "integrations.col_share": "\u5360\u6BD4",
  "integrations.no_version_data": "\u65E0\u7248\u672C\u6570\u636E",

  // ─── Health Page ───
  "health.title": "\u7CFB\u7EDF\u5065\u5EB7",
  "health.description":
    "\u7EC4\u4EF6\u72B6\u6001\u4E0E\u540E\u53F0\u4EFB\u52A1\u76D1\u63A7",
  "health.components": "\u7EC4\u4EF6",
  "health.api": "API",
  "health.neon": "Neon (\u6570\u636E\u5E93)",
  "health.kv": "KV \u5B58\u50A8",
  "health.r2": "R2 \u5B58\u50A8",
  "health.checked_at": "\u68C0\u67E5\u65F6\u95F4",
  "health.active_alerts": "\u6D3B\u52A8\u544A\u8B66",
  "health.alerts_checked_at": "\u544A\u8B66\u68C0\u67E5\u65F6\u95F4",
  "health.alerts_not_checked": "\u672A\u68C0\u67E5",
  "health.alerts_failed":
    "\u7CFB\u7EDF\u544A\u8B66\u52A0\u8F7D\u5931\u8D25\u3002",
  "health.no_active_alerts": "\u65E0\u6D3B\u52A8\u544A\u8B66",
  "health.alert_level": "\u7EA7\u522B",
  "health.alert_title": "\u544A\u8B66",
  "health.alert_detail": "\u8BE6\u60C5",
  "health.alert_runbook": "Runbook",
  "health.queue_stats": "\u961F\u5217\u7EDF\u8BA1",
  "health.poison_messages": "\u6BD2\u6D88\u606F",
  "health.pending_jobs": "\u7B49\u5F85\u4EFB\u52A1",
  "health.running_jobs": "\u8FD0\u884C\u4EFB\u52A1",
  "health.failed_24h": "\u5931\u8D25 (24h)",
  "health.cron_tasks": "\u5B9A\u65F6\u4EFB\u52A1",
  "health.col_name": "\u540D\u79F0",
  "health.col_status": "\u72B6\u6001",
  "health.col_detail": "\u8BE6\u60C5",

  // ─── Communications Page ───
  "communications.title": "\u901A\u4FE1",
  "communications.description":
    "\u53D1\u9001\u8FD0\u8425\u5E7F\u64AD\u5E76\u8FFD\u8E2A\u72B6\u6001",
  "communications.tab_compose": "\u521B\u5EFA",
  "communications.tab_history": "\u5386\u53F2",
  "communications.template": "\u6A21\u677F",
  "communications.reason": "\u539F\u56E0",
  "communications.params_json": "\u53C2\u6570 JSON",
  "communications.audience": "\u53D7\u4F17",
  "communications.audience_all": "\u6240\u6709\u6D3B\u8DC3\u7528\u6237",
  "communications.audience_affected": "\u53D7\u5F71\u54CD\u7528\u6237",
  "communications.affected_user_ids": "\u53D7\u5F71\u54CD\u7528\u6237 ID",
  "communications.submit": "\u53D1\u9001\u5E7F\u64AD",
  "communications.submitting": "\u53D1\u9001\u4E2D...",
  "communications.created": "\u5E7F\u64AD\u5DF2\u53D7\u7406\uFF1A{{id}}",
  "communications.params_invalid":
    "\u53C2\u6570\u5FC5\u987B\u662F JSON \u5BF9\u8C61\u3002",
  "communications.no_broadcasts": "\u6682\u65E0\u5E7F\u64AD\u8BB0\u5F55\u3002",
  "communications.col_broadcast": "\u5E7F\u64AD",
  "communications.col_template": "\u6A21\u677F",
  "communications.col_status": "\u72B6\u6001",
  "communications.col_progress":
    "\u5DF2\u5165\u961F / \u76EE\u6807\uFF08\u5931\u8D25\uFF09",
  "communications.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "communications.col_completed": "\u5B8C\u6210\u65F6\u95F4",
  "communications.detail_requested_by": "\u8BF7\u6C42\u4EBA",
  "communications.detail_updated": "\u66F4\u65B0\u65F6\u95F4",
  "communications.detail_audience": "\u53D7\u4F17",
  "communications.detail_params": "\u53C2\u6570",
  "communications.template.data_breach_notification":
    "\u6570\u636E\u6CC4\u9732",
  "communications.template.privacy_policy_changed":
    "\u9690\u79C1\u653F\u7B56\u53D8\u66F4",
  "communications.template.terms_changed": "\u6761\u6B3E\u53D8\u66F4",
  "communications.template.maintenance_window": "\u7EF4\u62A4\u7A97\u53E3",
  "communications.template.incident_alert": "\u4E8B\u6545\u544A\u8B66",
  "communications.template.incident_resolved": "\u4E8B\u6545\u5DF2\u6062\u590D",
  "communications.template.service_degraded_warning":
    "\u670D\u52A1\u964D\u7EA7",

  // ─── Dead Letter Queue Page ───
  "dlq.title": "\u6B7B\u4FE1\u961F\u5217",
  "dlq.description":
    "\u67E5\u770B\u5931\u8D25\u961F\u5217\u6D88\u606F\u5E76\u6309\u6761\u91CD\u653E",
  "dlq.origin_queue": "\u539F\u59CB\u961F\u5217",
  "dlq.from_date": "\u5F00\u59CB\u65E5\u671F",
  "dlq.to_date": "\u7ED3\u675F\u65E5\u671F",
  "dlq.search": "\u641C\u7D22",
  "dlq.initial_hint":
    "\u9009\u62E9\u961F\u5217\u548C\u65E5\u671F\u8303\u56F4\u540E\u641C\u7D22\u3002",
  "dlq.empty": "\u672A\u627E\u5230\u6B7B\u4FE1\u6761\u76EE\u3002",
  "dlq.next_page": "\u4E0B\u4E00\u9875",
  "dlq.col_entry": "\u6761\u76EE",
  "dlq.col_queue": "\u961F\u5217",
  "dlq.col_partition": "\u5206\u533A",
  "dlq.col_attempts": "\u5C1D\u8BD5\u6B21\u6570",
  "dlq.col_error": "\u6700\u540E\u9519\u8BEF",
  "dlq.col_size": "\u5927\u5C0F",
  "dlq.col_replay": "\u91CD\u653E",
  "dlq.col_uploaded": "\u4E0A\u4F20\u65F6\u95F4",
  "dlq.body_bytes": "\u6B63\u6587\u5B57\u8282",
  "dlq.uploaded_at": "\u4E0A\u4F20\u65F6\u95F4",
  "dlq.replayed_at": "\u91CD\u653E\u65F6\u95F4",
  "dlq.not_replayed": "\u672A\u91CD\u653E",
  "dlq.replay": "\u91CD\u653E\u6761\u76EE",
  "dlq.replaying": "\u91CD\u653E\u4E2D...",

  // ─── Backend API Coverage ───
  "api_coverage.title": "\u540E\u7AEF API \u6D4B\u8BD5\u8986\u76D6",
  "api_coverage.description":
    "\u6309\u771F\u5B9E\u540E\u7AEF\u7AEF\u70B9\u5217\u51FA API \u6E05\u5355\u3001\u76F4\u63A5 API \u5355\u5143\u6D4B\u8BD5\u548C\u8865\u5168\u72B6\u6001",
  "api_coverage.generated_at": "\u751F\u6210\u65F6\u95F4",
  "api_coverage.snapshot_failed":
    "\u540E\u7AEF API \u8986\u76D6\u5FEB\u7167\u52A0\u8F7D\u5931\u8D25\u3002",
  "api_coverage.snapshot_invalid":
    "\u540E\u7AEF API \u8986\u76D6\u5FEB\u7167\u683C\u5F0F\u65E0\u6548\u3002",
  "api_coverage.total_endpoints": "\u7AEF\u70B9\u603B\u6570",
  "api_coverage.tested_endpoints":
    "\u5DF2\u5173\u8054 API \u5355\u5143\u6D4B\u8BD5",
  "api_coverage.review_endpoints": "\u5F85\u590D\u6838\u7AEF\u70B9",
  "api_coverage.missing_endpoints": "\u7F3A\u5931\u7AEF\u70B9",
  "api_coverage.total_tests": "\u5168\u90E8\u6D4B\u8BD5\u7528\u4F8B",
  "api_coverage.linked_test_entries":
    "\u5DF2\u5173\u8054 API \u5355\u5143\u6D4B\u8BD5",
  "api_coverage.admin_frontend_exposed": "Admin UI \u5DF2\u66B4\u9732",
  "api_coverage.admin_frontend_unexposed": "Admin UI \u7F3A\u53E3",
  "api_coverage.endpoint_list": "API \u7AEF\u70B9\u6E05\u5355",
  "api_coverage.api_modules": "API \u6A21\u5757",
  "api_coverage.test_catalog": "\u6D4B\u8BD5\u7528\u4F8B\u5165\u53E3",
  "api_coverage.detail_title": "API \u8BE6\u60C5",
  "api_coverage.detail_description":
    "\u6807\u51C6 API \u6587\u6863\u4E0E\u6D4B\u8BD5\u8986\u76D6",
  "api_coverage.detail_overview": "\u6982\u89C8",
  "api_coverage.detail_contract": "\u8F93\u5165 / \u8F93\u51FA",
  "api_coverage.code_facts": "\u4EE3\u7801\u63D0\u53D6\u4E8B\u5B9E",
  "api_coverage.back_to_list": "\u8FD4\u56DE API \u6E05\u5355",
  "api_coverage.endpoint_not_found": "\u672A\u627E\u5230\u8BE5 API\u3002",
  "api_coverage.filtered_count": "\u663E\u793A {{visible}} / {{total}}",
  "api_coverage.api_endpoint": "API \u7AEF\u70B9",
  "api_coverage.api_name": "API \u540D\u79F0",
  "api_coverage.module": "\u6A21\u5757",
  "api_coverage.category": "\u5206\u7C7B",
  "api_coverage.test_status": "\u662F\u5426\u6D4B\u8BD5",
  "api_coverage.linked_tests": "\u5173\u8054 API \u5355\u5143\u6D4B\u8BD5",
  "api_coverage.frontend_exposure": "Admin UI \u66B4\u9732",
  "api_coverage.frontend_calls": "Admin \u524D\u7AEF\u8C03\u7528",
  "api_coverage.api_doc": "API \u6587\u6863",
  "api_coverage.auth": "\u8BA4\u8BC1",
  "api_coverage.status_codes": "\u72B6\u6001\u7801",
  "api_coverage.response": "\u54CD\u5E94",
  "api_coverage.request_fields": "\u8BF7\u6C42\u5B57\u6BB5",
  "api_coverage.error_codes": "\u9519\u8BEF\u7801",
  "api_coverage.middleware": "\u4E2D\u95F4\u4EF6 / \u9650\u6D41",
  "api_coverage.headers": "Header \u8F93\u5165",
  "api_coverage.path_params": "Path \u53C2\u6570",
  "api_coverage.query_params": "Query \u53C2\u6570",
  "api_coverage.body_reads": "Body \u8BFB\u53D6",
  "api_coverage.validators": "\u6821\u9A8C\u5668",
  "api_coverage.validation_checks": "\u6821\u9A8C / Guard",
  "api_coverage.response_facts": "\u54CD\u5E94\u5F62\u6001",
  "api_coverage.response_json": "JSON \u5185\u5BB9",
  "api_coverage.env_bindings": "Worker \u7ED1\u5B9A / DO",
  "api_coverage.service_calls": "\u670D\u52A1\u8C03\u7528",
  "api_coverage.logic_steps": "\u4EE3\u7801\u903B\u8F91",
  "api_coverage.field_name": "\u5B57\u6BB5",
  "api_coverage.field_type": "\u7C7B\u578B",
  "api_coverage.field_required": "\u5FC5\u586B",
  "api_coverage.field_description": "\u8BF4\u660E",
  "api_coverage.field_type.header": "HTTP Header",
  "api_coverage.field_type.path": "Path \u53C2\u6570",
  "api_coverage.field_type.query": "Query \u53C2\u6570",
  "api_coverage.field_type.body": "Body",
  "api_coverage.code_read": "\u4EE3\u7801\u8BFB\u53D6",
  "api_coverage.code_field.header":
    "\u540E\u7AEF\u4EE3\u7801\u901A\u8FC7 header \u8BFB\u53D6\u7684\u771F\u5B9E\u8F93\u5165\u3002",
  "api_coverage.code_field.path":
    "\u540E\u7AEF\u4EE3\u7801\u4ECE\u8DEF\u7531 path \u8BFB\u53D6\u7684\u771F\u5B9E\u8F93\u5165\u3002",
  "api_coverage.code_field.query":
    "\u540E\u7AEF\u4EE3\u7801\u4ECE URL query \u8BFB\u53D6\u7684\u771F\u5B9E\u8F93\u5165\u3002",
  "api_coverage.code_field.body":
    "\u8BF7\u6C42\u4F53\u8BFB\u53D6\u65B9\u5F0F\uFF1A{{value}}\u3002",
  "api_coverage.fact.reads_json": "\u8BFB\u53D6 JSON body",
  "api_coverage.fact.reads_valid_json":
    "\u8BFB\u53D6\u5DF2\u6821\u9A8C\u7684 JSON body",
  "api_coverage.fact.reads_form": "\u8BFB\u53D6 multipart/form body",
  "api_coverage.fact.reads_binary": "\u8BFB\u53D6\u4E8C\u8FDB\u5236 body",
  "api_coverage.fact.reads_text": "\u8BFB\u53D6\u6587\u672C body",
  "api_coverage.fact.reads_url": "\u8BFB\u53D6 URL / query",
  "api_coverage.logic.validate_ws":
    "\u6821\u9A8C Upgrade header \u5FC5\u987B\u4E3A websocket",
  "api_coverage.logic.read_query": "\u8BFB\u53D6 query \u53C2\u6570",
  "api_coverage.logic.parse_json": "\u89E3\u6790\u8BF7\u6C42 JSON",
  "api_coverage.logic.validate_schema":
    "\u6309 schema \u6821\u9A8C\u8BF7\u6C42",
  "api_coverage.logic.read_path": "\u8BFB\u53D6 path \u53C2\u6570",
  "api_coverage.logic.route_do": "\u8DEF\u7531\u5230 Durable Object",
  "api_coverage.logic.attach_expected_agent_id":
    "\u5C06 expected_agent_id \u4F20\u7ED9 AgentConnectionDO \u505A\u9996\u5E27\u6821\u9A8C",
  "api_coverage.logic.proxy_downstream":
    "\u5C06\u5347\u7EA7\u8BF7\u6C42\u4EE3\u7406\u5230\u4E0B\u6E38\u8FD0\u884C\u65F6",
  "api_coverage.logic.wait_until": "\u8C03\u5EA6\u5F02\u6B65\u526F\u4F5C\u7528",
  "api_coverage.logic.return_json": "\u8FD4\u56DE JSON \u54CD\u5E94",
  "api_coverage.validation.upgrade":
    "Upgrade header \u5FC5\u987B\u7B49\u4E8E websocket",
  "api_coverage.validation.schema": "\u6267\u884C schema \u6821\u9A8C",
  "api_coverage.validation.app_error":
    "\u901A\u8FC7 AppError \u8FD4\u56DE\u4E1A\u52A1\u9519\u8BEF",
  "api_coverage.validation.path_params": "\u8BFB\u53D6 path \u53C2\u6570",
  "api_coverage.validation.query_params": "\u8BFB\u53D6 query \u53C2\u6570",
  "api_coverage.response.proxy":
    "\u4EE3\u7406 Durable Object / \u4E0B\u6E38\u8FD0\u884C\u65F6\u54CD\u5E94",
  "api_coverage.response.json": "\u8FD4\u56DE JSON \u54CD\u5E94",
  "api_coverage.response.text": "\u8FD4\u56DE\u6587\u672C\u54CD\u5E94",
  "api_coverage.response.raw": "\u8FD4\u56DE\u539F\u59CB body \u54CD\u5E94",
  "api_coverage.response.redirect":
    "\u8FD4\u56DE\u91CD\u5B9A\u5411\u54CD\u5E94",
  "api_coverage.backfill": "\u8865\u5168\u72B6\u6001",
  "api_coverage.no_linked_tests":
    "\u672A\u627E\u5230\u76F4\u63A5 API \u5355\u5143\u6D4B\u8BD5\u7528\u4F8B\u3002",
  "api_coverage.untitled_endpoint": "\u672A\u547D\u540D API",
  "api_coverage.doc_found": "\u5DF2\u5173\u8054 API Design",
  "api_coverage.doc_missing": "API Design \u672A\u8986\u76D6",
  "api_coverage.doc_value_missing": "\u6587\u6863\u672A\u5217\u51FA",
  "api_coverage.no_error_codes":
    "\u672A\u4ECE API \u6587\u6863\u63D0\u53D6\u5230\u9519\u8BEF\u7801\u3002",
  "api_coverage.none": "\u65E0",
  "api_coverage.test_count": "{{count}} \u4E2A\u6D4B\u8BD5\u5165\u53E3",
  "api_coverage.frontend_call_count": "{{count}} \u6B21\u8C03\u7528",
  "api_coverage.frontend_exposed":
    "Admin UI \u5DF2\u66B4\u9732\uFF08{{count}} \u6B21\u8C03\u7528\uFF09",
  "api_coverage.frontend_unexposed": "Admin UI \u672A\u66B4\u9732",
  "api_coverage.frontend_not_applicable": "\u975E Admin \u7AEF\u70B9",
  "api_coverage.module_filter.all": "\u5168\u90E8\u6A21\u5757",
  "api_coverage.search_placeholder":
    "\u641C\u7D22 API \u8DEF\u5F84\u3001\u65B9\u6CD5\u6216\u6D4B\u8BD5\u6807\u9898",
  "api_coverage.tree_search_placeholder":
    "\u641C\u7D22\u6A21\u5757\u3001\u8DEF\u5F84\u3001\u65B9\u6CD5\u6216 API \u540D\u79F0",
  "api_coverage.open_test_catalog": "\u67E5\u770B\u6240\u6709\u6D4B\u8BD5",
  "api_coverage.test_search_placeholder":
    "\u641C\u7D22\u6D4B\u8BD5\u6807\u9898\u6216\u6D4B\u8BD5\u903B\u8F91",
  "api_coverage.page_count": "\u7B2C {{page}} / {{total}} \u9875",
  "api_coverage.linked_endpoint_count": "\u5173\u8054 API\uFF1A{{count}}",
  "api_coverage.method.all": "\u5168\u90E8\u65B9\u6CD5",
  "api_coverage.method.GET": "GET",
  "api_coverage.method.POST": "POST",
  "api_coverage.method.PUT": "PUT",
  "api_coverage.method.PATCH": "PATCH",
  "api_coverage.method.DELETE": "DELETE",
  "api_coverage.method.ALL": "ALL",
  "api_coverage.scope.all": "\u5168\u90E8\u8303\u56F4",
  "api_coverage.scope.admin": "Admin",
  "api_coverage.scope.public_api": "\u5BF9\u5916 API",
  "api_coverage.scope.internal": "\u5185\u90E8 API",
  "api_coverage.scope.websocket": "WebSocket",
  "api_coverage.status.all": "\u5168\u90E8\u72B6\u6001",
  "api_coverage.status.tested": "\u5DF2\u6D4B",
  "api_coverage.status.needs_review": "\u5F85\u590D\u6838",
  "api_coverage.status.missing": "\u7F3A\u5931",
  "api_coverage.strength.explicit": "\u660E\u786E\u547D\u4E2D",
  "api_coverage.strength.domain": "\u540C\u6A21\u5757",
  "api_coverage.backfill.tested":
    "\u5DF2\u6709\u660E\u786E API \u6D4B\u8BD5\u5165\u53E3\u3002",
  "api_coverage.backfill.needs_review":
    "\u53EA\u627E\u5230\u540C\u6A21\u5757\u6D4B\u8BD5\uFF0C\u9700\u786E\u8BA4\u662F\u5426\u771F\u6B63\u8986\u76D6\u8BE5 API\u3002",
  "api_coverage.backfill.missing":
    "\u9700\u8865\u4E00\u4E2A\u76F4\u63A5\u8C03\u7528\u8BE5 API \u5E76\u65AD\u8A00\u4E3B\u6D41\u7A0B / \u5F02\u5E38\u5206\u652F\u7684\u6D4B\u8BD5\u3002",

  // ─── Backend API Tests ───
  "api_tests.title": "\u540E\u7AEF API \u6D4B\u8BD5\u7528\u4F8B",
  "api_tests.description":
    "\u6309\u5355\u5143\u3001\u96C6\u6210\u3001\u5B89\u5168\u3001\u5173\u952E\u8DEF\u5F84\u548C\u7AEF\u5230\u7AEF\u573A\u666F\u67E5\u770B\u6D4B\u8BD5\u76EE\u6807\u4E0E\u5177\u4F53\u903B\u8F91",
  "api_tests.open_api_coverage": "\u67E5\u770B API \u8986\u76D6",
  "api_tests.test_tree": "\u6D4B\u8BD5\u5206\u7C7B",
  "api_tests.tree_search_placeholder":
    "\u641C\u7D22\u6D4B\u8BD5\u7C7B\u578B\u3001\u8DEF\u5F84\u3001\u6807\u9898\u6216\u903B\u8F91",
  "api_tests.test_not_found": "\u672A\u627E\u5230\u8BE5\u6D4B\u8BD5\u3002",
  "api_tests.test_type": "\u6D4B\u8BD5\u7C7B\u578B",
  "api_tests.test_goal": "\u6D4B\u8BD5\u76EE\u6807",
  "api_tests.test_method": "\u6267\u884C\u65B9\u5F0F",
  "api_tests.source_path": "\u6D4B\u8BD5\u5165\u53E3",
  "api_tests.test_logic": "\u6D4B\u8BD5\u903B\u8F91",
  "api_tests.linked_apis": "\u76F4\u63A5\u5173\u8054 API",
  "api_tests.no_linked_apis":
    "\u8BE5\u6D4B\u8BD5\u4E0D\u4F5C\u4E3A\u67D0\u4E2A API \u7684\u76F4\u63A5\u5355\u5143\u8986\u76D6\u8BC1\u636E\u3002",
  "api_tests.type_tabs": "\u6D4B\u8BD5\u573A\u666F Tab",
  "api_tests.tab_stats":
    "{{files}} \u4E2A\u6587\u4EF6 \u00B7 {{tests}} \u6761\u6D4B\u8BD5",
  "api_tests.file_index": "\u6587\u4EF6\u7D22\u5F15",
  "api_tests.file_count": "{{files}} / {{total}} \u4E2A\u6587\u4EF6",
  "api_tests.file_search_placeholder":
    "\u641C\u7D22\u6587\u4EF6\u8DEF\u5F84\u3001\u6D4B\u8BD5\u6807\u9898\u6216\u903B\u8F91",
  "api_tests.file_tests_count":
    "{{tests}} \u6761\u6D4B\u8BD5 \u00B7 {{apis}} \u4E2A\u5173\u8054 API",
  "api_tests.file_not_found":
    "\u672A\u627E\u5230\u8BE5\u6D4B\u8BD5\u6587\u4EF6\u3002",
  "api_tests.file_tabs": "\u6587\u4EF6\u8BE6\u60C5 Tab",
  "api_tests.file_tab_cases": "\u6D4B\u8BD5\u7528\u4F8B",
  "api_tests.file_tab_apis": "\u5173\u8054 API",
  "api_tests.file_total_cases": "{{tests}} \u6761\u6D4B\u8BD5\u7528\u4F8B",
  "api_tests.file_total_apis": "{{apis}} \u4E2A\u5173\u8054 API",
  "api_tests.type.api_unit": "API \u5355\u5143\u6D4B\u8BD5",
  "api_tests.type.unit": "\u5355\u5143 / \u7EC4\u4EF6\u6D4B\u8BD5",
  "api_tests.type.integration": "\u96C6\u6210\u6D4B\u8BD5",
  "api_tests.type.security": "\u5B89\u5168\u6D4B\u8BD5",
  "api_tests.type.critical_path": "\u5173\u952E\u8DEF\u5F84\u6D4B\u8BD5",
  "api_tests.type.performance": "\u6027\u80FD / \u57FA\u7EBF\u6D4B\u8BD5",
  "api_tests.type.desktop_e2e": "\u684C\u9762\u7AEF E2E",
  "api_tests.type.maestro": "\u539F\u751F\u7AEF Maestro \u6D41\u7A0B",
  "api_tests.type.other": "\u5176\u4ED6\u6D4B\u8BD5",
  "api_tests.goal.api_unit":
    "\u76EE\u6807\uFF1A\u76F4\u63A5\u8C03\u7528\u5355\u4E2A API\uFF0C\u9A8C\u8BC1\u8BE5 API \u7684\u8F93\u5165\u3001\u6821\u9A8C\u3001\u4E3B\u6D41\u54CD\u5E94\u548C\u9519\u8BEF\u5206\u652F\u3002API \u8986\u76D6\u9875\u53EA\u4F7F\u7528\u8FD9\u7C7B\u4F5C\u4E3A\u76F4\u63A5\u5173\u8054\u3002",
  "api_tests.goal.unit":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1\u51FD\u6570\u3001service\u3001store\u3001UI \u7EC4\u4EF6\u7B49\u5C40\u90E8\u903B\u8F91\uFF0C\u4E0D\u4EE3\u8868\u67D0\u4E2A API \u5951\u7EA6\u5DF2\u76F4\u63A5\u8986\u76D6\u3002",
  "api_tests.goal.integration":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1\u591A\u4E2A API\u3001DB\u3001KV\u3001Queue\u3001DO \u6216\u4E1A\u52A1\u6D41\u7A0B\u4E4B\u95F4\u7684\u534F\u4F5C\uFF0C\u4E0D\u7528\u6765\u4F5C\u4E3A\u5355\u4E2A API \u7684\u76F4\u63A5\u8986\u76D6\u3002",
  "api_tests.goal.security":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1\u8BA4\u8BC1\u3001\u6388\u6743\u3001\u9694\u79BB\u3001\u9632\u6CC4\u6F0F\u548C\u653B\u51FB\u9762\u9632\u62A4\uFF0C\u901A\u5E38\u8DE8\u591A\u4E2A API \u6216\u8D44\u6E90\u3002",
  "api_tests.goal.critical_path":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1\u53D1\u7248\u5FC5\u987B\u6210\u529F\u7684\u5173\u952E\u4E1A\u52A1\u94FE\u8DEF\uFF0C\u5173\u6CE8\u7AEF\u5230\u7AEF\u7ED3\u679C\u800C\u4E0D\u662F\u5355 API \u5951\u7EA6\u3002",
  "api_tests.goal.performance":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1\u5EF6\u8FDF\u3001\u541E\u5410\u3001\u8D44\u6E90\u6D88\u8017\u548C\u56DE\u5F52\u57FA\u7EBF\uFF0C\u4E0D\u4EE3\u8868\u529F\u80FD\u5951\u7EA6\u5DF2\u5B8C\u6574\u8986\u76D6\u3002",
  "api_tests.goal.desktop_e2e":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1\u684C\u9762\u7AEF\u771F\u5B9E\u7528\u6237\u6D41\u7A0B\u548C\u58F3\u5C42\u96C6\u6210\uFF0C\u7528\u4E8E\u7AEF\u4E0A\u9A8C\u6536\u800C\u975E API \u76F4\u63A5\u8986\u76D6\u3002",
  "api_tests.goal.maestro":
    "\u76EE\u6807\uFF1A\u9A8C\u8BC1 iOS / Android \u539F\u751F\u7AEF\u53EF\u89C1\u7528\u6237\u6D41\u7A0B\uFF0C\u8986\u76D6\u591A\u7AEF\u884C\u4E3A\u548C UI \u72B6\u6001\u3002",
  "api_tests.goal.other":
    "\u76EE\u6807\uFF1A\u5176\u4ED6\u8F85\u52A9\u6216\u5DE5\u5177\u7C7B\u6D4B\u8BD5\uFF0C\u9700\u6309\u6D4B\u8BD5\u6807\u9898\u548C\u5165\u53E3\u5224\u65AD\u5176\u9A8C\u8BC1\u8303\u56F4\u3002",

  // ─── Crashes ───
  "crashes.title": "\u5D29\u6E83\u62A5\u544A",
  "crashes.description":
    "\u81EA\u6258\u7BA1 /v1/crash \u7AEF\u70B9\u4E0A\u62A5\u7684\u5206\u7EC4\u5D29\u6E83\u8BB0\u5F55",
  "crashes.filter_platform": "\u5E73\u53F0",
  "crashes.filter_since": "\u65F6\u95F4\u8303\u56F4",
  "crashes.filter_all": "\u5168\u90E8",
  "crashes.since_24h": "24 \u5C0F\u65F6",
  "crashes.since_7d": "7 \u5929",
  "crashes.since_30d": "30 \u5929",
  "crashes.no_groups":
    "\u5F53\u524D\u7A97\u53E3\u65E0\u5D29\u6E83\u8BB0\u5F55\u3002",
  "crashes.col_error": "\u9519\u8BEF",
  "crashes.col_platform": "\u5E73\u53F0",
  "crashes.col_count": "\u6B21\u6570",
  "crashes.col_first_seen": "\u9996\u6B21\u89C1\u5230",
  "crashes.col_last_seen": "\u6700\u8FD1\u89C1\u5230",
  "crashes.samples_title": "\u6700\u8FD1\u6837\u672C",
  "crashes.back_to_list": "\u8FD4\u56DE\u5217\u8868",
  "crashes.sample_stack": "\u5806\u6808",
  "crashes.sample_breadcrumbs": "\u9762\u5305\u5C51",
  "crashes.sample_extra": "\u9644\u52A0\u4E0A\u4E0B\u6587",
  "crashes.sample_app_version": "\u5E94\u7528\u7248\u672C",
  "crashes.sample_os_version": "\u7CFB\u7EDF\u7248\u672C",
  "crashes.sample_is_fatal": "\u81F4\u547D",
  "crashes.sample_component_stack": "\u7EC4\u4EF6\u6808",
  "crashes.sample_device_hash": "\u8BBE\u5907\u6807\u8BC6",
  "crashes.sample_user_hash": "\u7528\u6237\u6807\u8BC6",
  "crashes.sample_client_time": "\u5BA2\u6237\u7AEF\u65F6\u95F4",
  "crashes.group_count": "{{count}} \u6B21\u53D1\u751F",

  // ─── Relations ───
  "relations.title": "\u5173\u7CFB",
  "relations.description":
    "\u67E5\u770B\u548C\u5BA1\u8BA1\u7528\u6237\u5173\u7CFB",
  "relations.col_type": "\u7C7B\u578B",
  "relations.col_user_a": "\u7528\u6237 A",
  "relations.col_user_b": "\u7528\u6237 B / Agent",
  "relations.col_status": "\u72B6\u6001",
  "relations.col_conversation": "\u4F1A\u8BDD",
  "relations.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "relations.all_types": "\u6240\u6709\u7C7B\u578B",
  "relations.all_status": "\u6240\u6709\u72B6\u6001",
  "relations.search_placeholder":
    "\u6309\u540D\u79F0\u6216\u90AE\u7BB1\u641C\u7D22...",
  "relations.no_relations": "\u672A\u627E\u5230\u5173\u7CFB\u8BB0\u5F55\u3002",
  "relations.page_info":
    "{{total}} \u6761\u5173\u7CFB \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Blocks ───
  "blocks.title": "\u5C4F\u853D",
  "blocks.description":
    "\u67E5\u770B\u5C4F\u853D\u8BB0\u5F55\u4EE5\u8C03\u67E5\u6EE5\u7528",
  "blocks.col_blocker": "\u5C4F\u853D\u8005",
  "blocks.col_blocked": "\u88AB\u5C4F\u853D\u8005",
  "blocks.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "blocks.blocker_placeholder": "\u5C4F\u853D\u8005 UUID...",
  "blocks.blocked_placeholder": "\u88AB\u5C4F\u853D\u8005 UUID...",
  "blocks.no_blocks": "\u672A\u627E\u5230\u5C4F\u853D\u8BB0\u5F55\u3002",
  "blocks.page_info":
    "{{total}} \u6761\u5C4F\u853D \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Conversations ───
  "conversations.title": "\u4F1A\u8BDD",
  "conversations.description":
    "\u8BCA\u65AD\u4F1A\u8BDD\u72B6\u6001\u548C\u6210\u5458",
  "conversations.col_id": "ID",
  "conversations.col_type": "\u7C7B\u578B",
  "conversations.col_members": "\u6210\u5458",
  "conversations.col_last_activity": "\u6700\u540E\u6D3B\u52A8",
  "conversations.col_frozen": "\u51BB\u7ED3",
  "conversations.col_terminated": "\u7EC8\u6B62",
  "conversations.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "conversations.all_types": "\u6240\u6709\u7C7B\u578B",
  "conversations.all_frozen": "\u5168\u90E8",
  "conversations.frozen_yes": "\u5DF2\u51BB\u7ED3",
  "conversations.frozen_no": "\u672A\u51BB\u7ED3",
  "conversations.all_terminated": "\u5168\u90E8",
  "conversations.terminated_yes": "\u5DF2\u7EC8\u6B62",
  "conversations.terminated_no": "\u672A\u7EC8\u6B62",
  "conversations.search_placeholder": "\u4F1A\u8BDD ID...",
  "conversations.no_conversations": "\u672A\u627E\u5230\u4F1A\u8BDD\u3002",
  "conversations.page_info":
    "{{total}} \u4E2A\u4F1A\u8BDD \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Conversation Detail ───
  "conv_detail.title": "\u4F1A\u8BDD\u8BE6\u60C5",
  "conv_detail.info": "\u4FE1\u606F",
  "conv_detail.members": "\u6210\u5458",
  "conv_detail.message_stats": "\u6D88\u606F\u7EDF\u8BA1",
  "conv_detail.col_member": "\u6210\u5458",
  "conv_detail.col_type": "\u7C7B\u578B",
  "conv_detail.col_unread": "\u672A\u8BFB",
  "conv_detail.col_muted": "\u9759\u97F3",
  "conv_detail.col_pinned": "\u7F6E\u9876",
  "conv_detail.col_hidden": "\u9690\u85CF",
  "conv_detail.col_joined": "\u52A0\u5165\u65F6\u95F4",
  "conv_detail.total_messages": "\u6D88\u606F\u603B\u6570",
  "conv_detail.recalled": "\u5DF2\u64A4\u56DE",
  "conv_detail.by_type": "\u6309\u5185\u5BB9\u7C7B\u578B",
  "conv_detail.by_sender": "\u6309\u53D1\u9001\u8005\u7C7B\u578B",
  "conv_detail.not_found": "\u672A\u627E\u5230\u4F1A\u8BDD\u3002",

  // ─── Messages Tab ───
  "messages_tab.title": "\u6D88\u606F",
  "messages_tab.total_messages": "\u6D88\u606F\u603B\u6570",
  "messages_tab.human_ratio": "\u4EBA\u7C7B\u5360\u6BD4",
  "messages_tab.agent_ratio": "Agent \u5360\u6BD4",
  "messages_tab.recall_rate": "\u64A4\u56DE\u7387",
  "messages_tab.daily_trends": "\u6BCF\u65E5\u6D88\u606F\u8D8B\u52BF",
  "messages_tab.type_distribution": "\u5185\u5BB9\u7C7B\u578B\u5206\u5E03",
  "messages_tab.col_date": "\u65E5\u671F",
  "messages_tab.col_human": "\u4EBA\u7C7B",
  "messages_tab.col_agent": "Agent",
  "messages_tab.col_system": "\u7CFB\u7EDF",
  "messages_tab.col_total": "\u603B\u8BA1",
  "messages_tab.col_content_type": "\u5185\u5BB9\u7C7B\u578B",
  "messages_tab.col_count": "\u6570\u91CF",
  "messages_tab.col_percentage": "\u5360\u6BD4",

  // ─── Sidebar: Invites ───
  "nav.invites": "\u9080\u8BF7",
  "nav.invites.applications": "\u7533\u8BF7\u5217\u8868",
  "nav.invites.codes": "\u9080\u8BF7\u7801",

  // ─── Applications ───
  "applications.title": "\u7533\u8BF7\u5217\u8868",
  "applications.description":
    "\u7BA1\u7406\u9080\u8BF7\u5236\u6CE8\u518C\u7533\u8BF7",
  "applications.tab_all": "\u5168\u90E8",
  "applications.tab_pending": "\u5F85\u5BA1\u6838",
  "applications.tab_approved": "\u5DF2\u901A\u8FC7",
  "applications.tab_rejected": "\u5DF2\u62D2\u7EDD",
  "applications.col_email": "\u90AE\u7BB1",
  "applications.col_name": "\u59D3\u540D",
  "applications.col_role": "\u89D2\u8272",
  "applications.col_reason": "\u7533\u8BF7\u7406\u7531",
  "applications.col_status": "\u72B6\u6001",
  "applications.col_date": "\u65E5\u671F",
  "applications.col_actions": "\u64CD\u4F5C",
  "applications.approve": "\u901A\u8FC7",
  "applications.reject": "\u62D2\u7EDD",
  "applications.reject_title": "\u62D2\u7EDD\u7533\u8BF7",
  "applications.reject_desc":
    "\u8BF7\u63D0\u4F9B\u62D2\u7EDD\u8BE5\u7533\u8BF7\u7684\u7406\u7531\u3002",
  "applications.no_applications":
    "\u672A\u627E\u5230\u7533\u8BF7\u8BB0\u5F55\u3002",
  "applications.page_info":
    "\u5171 {{total}} \u6761\u7533\u8BF7 \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Invite Codes ───
  "invite_codes.title": "\u9080\u8BF7\u7801",
  "invite_codes.description": "\u7BA1\u7406\u6CE8\u518C\u9080\u8BF7\u7801",
  "invite_codes.create_code": "\u521B\u5EFA\u9080\u8BF7\u7801",
  "invite_codes.all_status": "\u5168\u90E8\u72B6\u6001",
  "invite_codes.status_available": "\u53EF\u7528",
  "invite_codes.status_claimed": "\u5DF2\u4F7F\u7528",
  "invite_codes.status_expired": "\u5DF2\u8FC7\u671F",
  "invite_codes.col_code": "\u9080\u8BF7\u7801",
  "invite_codes.col_issued_by": "\u7B7E\u53D1\u4EBA",
  "invite_codes.col_claimed_by": "\u4F7F\u7528\u4EBA",
  "invite_codes.col_status": "\u72B6\u6001",
  "invite_codes.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "invite_codes.col_expires": "\u8FC7\u671F\u65F6\u95F4",
  "invite_codes.never": "\u6C38\u4E0D\u8FC7\u671F",
  "invite_codes.no_codes": "\u672A\u627E\u5230\u9080\u8BF7\u7801\u3002",
  "invite_codes.page_info":
    "\u5171 {{total}} \u4E2A\u9080\u8BF7\u7801 \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Date Picker ───
  "space_reports.title": "Space \u4E3E\u62A5\u961F\u5217",
  "space_reports.description":
    "\u5BA1\u6838\u7528\u6237\u5BF9\u516C\u5F00 Space \u5185\u5BB9\u7684\u4E3E\u62A5\u3002Uphold \u4F1A\u7ACB\u5373\u4E0B\u67B6\u5BF9\u5E94\u5185\u5BB9\u3002",
  "space_reports.empty":
    "\u5F53\u524D\u7B5B\u9009\u4E0B\u6CA1\u6709\u4E3E\u62A5\u3002",
  "space_reports.col_item": "\u5185\u5BB9",
  "space_reports.col_reason": "\u539F\u56E0",
  "space_reports.col_status": "\u72B6\u6001",
  "space_reports.col_reported_at": "\u4E3E\u62A5\u65F6\u95F4",
  "space_reports.col_actions": "\u64CD\u4F5C",
  "space_reports.action_uphold": "\u652F\u6301\u4E3E\u62A5\u5E76\u4E0B\u67B6",
  "space_reports.action_dismiss": "\u9A73\u56DE",
  "space_reports.confirm_uphold":
    "\u786E\u8BA4\u652F\u6301\u8BE5\u4E3E\u62A5\u5E76\u4E0B\u67B6\u5185\u5BB9?\u8FD9\u4F1A\u5199\u5165\u5BA1\u8BA1\u65E5\u5FD7,\u65E0\u6CD5\u5728\u6B64\u9875\u64A4\u9500\u3002",
  "space_reports.confirm_dismiss":
    "\u786E\u8BA4\u9A73\u56DE?\u5185\u5BB9\u4FDD\u6301\u4E0A\u7EBF\u3002\u540C\u6837\u4F1A\u5199\u5165\u5BA1\u8BA1\u65E5\u5FD7\u3002",
  "space_reports.taken_down_at": "\u4E0B\u67B6\u4E8E",
  "space_reports.filter_pending": "\u5F85\u5BA1\u6838",
  "space_reports.filter_auto_upheld": "\u81EA\u52A8\u4E0B\u67B6",
  "space_reports.filter_upheld": "\u5DF2\u652F\u6301",
  "space_reports.filter_dismissed": "\u5DF2\u9A73\u56DE",
  "space_reports.filter_all": "\u5168\u90E8",
  "space_reports.status_pending": "\u5F85\u5BA1\u6838",
  "space_reports.status_auto_upheld": "\u81EA\u52A8\u4E0B\u67B6",
  "space_reports.status_upheld": "\u5DF2\u652F\u6301",
  "space_reports.status_dismissed": "\u5DF2\u9A73\u56DE",
  "space_reports.reason_spam": "\u5783\u573E\u5185\u5BB9",
  "space_reports.reason_harassment": "\u9A9A\u6270",
  "space_reports.reason_nsfw": "\u4E0D\u9002\u5F53\u5185\u5BB9",
  "space_reports.reason_illegal": "\u8FDD\u6CD5",
  "space_reports.reason_misinformation": "\u865A\u5047\u4FE1\u606F",
  "space_reports.reason_other": "\u5176\u4ED6",

  "date_picker.date": "\u65E5\u671F",
  "date_picker.7d": "7 \u5929",
  "date_picker.30d": "30 \u5929",
  "date_picker.90d": "90 \u5929",
  "date_picker.1y": "1 \u5E74",
  "date_picker.custom": "\u81EA\u5B9A\u4E49",
};
